import { Link } from 'react-router-dom';
import { featuredCards } from '@/mocks/home';

export default function FeaturedGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10 md:mb-14">
            <div className="flex items-center gap-3 mb-3">
              <span className="font-heading text-xs tracking-widest text-foreground-500 uppercase">
                HEILIAO CHIGUA
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950">
              精选吃瓜专区
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {featuredCards.map((card) => (
              <FeaturedCard key={card.id} card={card} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function FeaturedCard({ card }: { card: typeof featuredCards[0] }) {
  if (card.type === 'dark') {
    return (
      <Link
        to="/category/all"
        className="group block rounded-2xl bg-foreground-950 p-6 md:p-8 transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
      >
        <div className="w-12 h-12 rounded-xl bg-foreground-800/50 flex items-center justify-center mb-6">
          <span className="text-2xl">{card.icon}</span>
        </div>
        <h3 className="font-heading text-xl md:text-2xl text-background-50 mb-3">
          {card.title}
        </h3>
        <p className="text-sm text-foreground-300 leading-relaxed">
          {card.description}
        </p>
      </Link>
    );
  }

  if (card.type === 'image') {
    return (
      <Link
        to="/category/all"
        className="group block rounded-2xl overflow-hidden relative h-80 md:h-96 transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
      >
        <img
          src={card.image}
          alt={card.title}
          title={card.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-xs text-background-50 font-medium">
            <i className="ri-star-line mr-1"></i>
            {card.category}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h3 className="font-heading text-xl md:text-2xl text-background-50">
            {card.title}
          </h3>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to="/category/all"
      className="group block rounded-2xl bg-background-50 p-6 md:p-8 transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
        {card.title}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed mb-6">
        {card.description}
      </p>
      <div className="rounded-xl overflow-hidden h-40 md:h-48">
        <img
          src={card.image}
          alt={card.title}
          title={card.title}
          className="w-full h-full object-cover object-top"
        />
      </div>
    </Link>
  );
}